import { Component } from '@theme/component';

/**
 * @typedef {Object} ContactFormRefs
 * @property {HTMLSelectElement} categorySelect - "How can we help?" category select
 * @property {HTMLElement[]} [categoryGroup] - Conditional field groups, one per category
 */

/**
 * Shows/hides and enables/disables the conditional fields that belong to the
 * category selected in "How can we help?", so only the active category's
 * fields are submitted with the contact form.
 *
 * @extends {Component<ContactFormRefs>}
 */
class ContactForm extends Component {
  requiredRefs = ['categorySelect'];

  connectedCallback() {
    super.connectedCallback();
    this.#syncCategoryGroups();
  }

  /**
   * @param {Event} _event
   */
  onCategoryChange(_event) {
    this.#syncCategoryGroups();
  }

  #syncCategoryGroups() {
    const selected = this.refs.categorySelect.value;

    for (const group of this.refs.categoryGroup ?? []) {
      const isActive = group.dataset.category === selected;

      group.hidden = !isActive;

      for (const field of group.querySelectorAll('input, select, textarea')) {
        if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) {
          continue;
        }

        field.disabled = !isActive;

        if (!isActive) field.value = '';
      }
    }
  }
}

customElements.define('contact-form', ContactForm);
